import React, { useCallback, useContext, useState, useEffect } from 'react';


import { getWeekNum } from "../../utils";
import PanelSearch from './search';
import QueryString from 'query-string';
import { format, getDay, parse, setDay, addDays } from 'date-fns';
import PanelBookingsSidebar from "./sidebar";
import { convertFieldsToGraphqlVariables } from '../../graphql-helpers';
import { PanelGrid } from './grid';
import {useLocation, useNavigate, useParams} from 'react-router';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { Panel,  useCreatePanelBookingMutationMutation, useSearchPanelsQueryQuery } from '../../generated/graphql';
import PanelBookingsInspector from './inspector';
import { get } from 'immutadot/core';
import { WebSocketContext } from '../../contexts/websocket';
import { useRecordModuleHistory} from '../../contexts/module-history-context';
import panelBookingsExport from './export';
import {Accordion, AccordionDetails, AccordionSummary, Button, Typography} from "@mui/material";
import {useSnackbar} from "notistack";
import { ModalWindow } from '../../components/ModalWindow';




interface InspectedPanelBookingPane {
  weekNum: number,
  panelId: number,
  inspectorId: number
}


let today = new Date();
today = getDay(today) < 1 ? setDay(today, -5, { weekStartsOn: 1 }) : setDay(today, 1, { weekStartsOn: 1 })
today = addDays(today, 7);
const todayString = format(today, 'yyyy-MM-dd');

const PanelBookings = () => {
  const bookingProps = useParams();
  console.log('[PanelBookings]','Render - booking props are',bookingProps);
  const bookingType=bookingProps.bookingType||'Pencil';
  const bookingCampaignId=bookingProps.bookingCampaignId||'';
  const bookingIsSlot=bookingProps.bookingIsSlot?parseInt(bookingProps.bookingIsSlot):0;
  const bookingNumWeeks=bookingProps.bookingNumWeeks?parseInt(bookingProps.bookingNumWeeks):2;
  const [isSearchOpen, setIsSearchOpen] = useState(true);
  //const [bookingOptions, setBookingOptions] = useState(null);
  const webSocketContext = useContext(WebSocketContext);
  const recordModuleHistory = useRecordModuleHistory();
  const [query, setQuery] = useState({ array: null, params: null, qlVariables: null, week: today, weekString: null, weekNum: null });
  const [inspectedRecord, setInspectedRecord] = useState<InspectedPanelBookingPane | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const toolbarContext = useContext(ToolbarContext);
  const [createPanelBooking] = useCreatePanelBookingMutationMutation();
//  const [createPanelBooking] = useMutation<Mutation>(createPanelBookingMutation);
  const [resultsOrder, setOrder] = useState([]);
  const [results,setResults]= useState<Panel[]>([]);
  const {enqueueSnackbar} = useSnackbar();
  useEffect(() => {
    const rawParsedQueryString = QueryString.parse(location.search);
    let dateString = null;
    const queryStringArray = [];
    let status = null;
    Object.entries(rawParsedQueryString).forEach(function ([k, v]) {
      const name = k.split('-');
      switch (name[0]) {
        case 'date':
          dateString = v.toString();
          break;
        case 'status':
          status = v.toString();
          queryStringArray.push({ name: name[0], type: name[1], value: v });
          break;
        default:
          queryStringArray.push({ name: name[0], type: name[1], value: v });
          break;
      }
    });
    if (status == null) {
      queryStringArray.push({ name: 'status', type: 'lookup', value: 'Live' });
    }
    const date = dateString ? parse(dateString, 'yyyy-MM-dd', today) : today;
    const params = convertFieldsToGraphqlVariables(queryStringArray);
    const weekNum = getWeekNum(date);
    params.start_week = weekNum;
    params.num_weeks = 5;
    //console.log('params are', params, 'QSA', queryStringArray);
    setQuery({
      array: queryStringArray, params: rawParsedQueryString, qlVariables: params,
      week: date,
      weekString: format(date, 'yyyy-MM-dd'),
      weekNum: weekNum
    });

    webSocketContext.setWatches('panelBookings', [weekNum, weekNum + 1, weekNum + 2, weekNum + 3, weekNum + 4]);

  }, [location.search]);
  const setBookingOptions = useCallback((values)=> {
    navigate('/panel-bookings/'+(values.isSlot?1:0) +'/'+(values.campaignId?values.campaignId:'0')+'/'+
    values.numWeeks+'/'+values.bookingType
    + location.search);

    return;
  },[location.search]);
  var skip = Object.keys(query?.qlVariables??{}).length<4;
  const panelResults = useSearchPanelsQueryQuery({
    variables: query.qlVariables,
    skip: skip,
    fetchPolicy:'network-only'
  });
const [isOptionalModalShown,setOptionModalShown] = useState(false);
const doOptionAllPanels = useCallback(()=>{
  setOptionModalShown(true);
},[]);
const doOptionAllPanelsAction = useCallback(()=>{
  const errors = [];
  panelResults?.data?.panelSearch?.forEach((value)=>{
//    console.log('wouldbook',value.id,query.weekNum);
    try {
      bookDate(value.id,query.weekNum,true);
    } catch(e) {
      errors.push(e.message);
    }
  });
  if(errors.length) {
    enqueueSnackbar('Errors occured during processing: '+errors.join("\n"),{variant:'warning'});
  } else {
    enqueueSnackbar('Panel bookings processed successfully',{variant:'success'});
  }
},[panelResults?.data,query.weekNum]);

  // we parse the query string here and before render
  const doShowSearch = useCallback(() => {
    setIsSearchOpen(true);
  }, [setIsSearchOpen]);
  //  this.parseQueryString();
  const doExport = useCallback(() => {
    const pd =  panelResults?.data?.panelSearch;
    if(!pd) return;
    panelBookingsExport(pd,query.weekNum);
  },[panelResults.data,query.weekNum]);
  useEffect(() => {
    toolbarContext.setToolbar(
      {
        primary: [
          { type: 'button', label: 'Search', tooltip: 'Search', icon: 'search', callback: doShowSearch }
        ],
        title: 'Panel Bookings',
        secondary: [
          {type:'button',label:'Availability Export',tooltip:'Generate export',icon:'download',callback:doExport }
        ]
      });
  }, [doShowSearch,doExport]);


  //  this.setQueryString();
  const goToQueryString = useCallback((inputQueryStringArray, date) => {
    const qs = {};
    inputQueryStringArray.forEach((val) => {
      qs[val.name + '-' + val.type] = val.value;
    });
    if (date !== todayString) {
      qs['date'] = date;
    }
    navigate(location.pathname + '?' + QueryString.stringify(qs));
  }, [navigate, location.pathname]);

  const doSearch = useCallback((fields, date) => {
    setIsSearchOpen(false);
    goToQueryString(fields, date);
  }, [location.pathname]);
  
  useEffect(()=> {
      recordModuleHistory('panel-bookings');
  },[recordModuleHistory,location]);

  const doCancelSearch = useCallback(() => {
    setIsSearchOpen(false);
  }, []);

  function getArgs() {
    const res = document.location.href.split('/');
    console.log('args0',res);
    //const qs = QueryString.parse(document.location.search);
    //const date = qs&&qs.date ? parse(qs.date, 'yyyy-MM-dd', today) : today;
    return {
      campaignId:res[5],
      isSlot: !!parseInt(res[4]),
      numWeeks: parseInt(res[6]),
      status: res[7]?(res[7].split('?')[0]):'',
//      date:date
    };
  }
  console.log('args are',getArgs());
  // we want this to NOT re-render the entire sodding grid every time a booking parameter changes /duh
  const bookDate = useCallback(async (panelId, weekNum,silent=false) => {
    console.log('[PanelBookings]','BOOK DATE',bookingProps,bookingCampaignId,getArgs());
    const args = getArgs();
    if (!args.campaignId||args.campaignId=='0') {
      if(!silent) {
        enqueueSnackbar('Please select campaign', {variant:'error'});
      }
      return;
    }

    if (!args.numWeeks) {
      if(!silent) {
        enqueueSnackbar('Please enter a valid number of weeks', {variant:'error'});
      }
      return;
    }
    args.panelId = panelId;
    args.weekNumber = weekNum;
/*    const variables = {
      campaignId: bookingCampaignId,
      weekNumber: weekNum,
      numWeeks: bookingNumWeeks,
      panelId: panelId,
      status: bookingType,
      isSlot: !!bookingIsSlot
    };*/
    if(!silent) {
      enqueueSnackbar('Booking date', {variant:"info"});
    }
    try {
      //var data = 
      await createPanelBooking({ variables: args });
      if(!silent) {
        enqueueSnackbar('Booking Successful',{variant:'success'});
        inspectDate(panelId, weekNum);
      }
    } catch (errors) {
      if (errors) {
        const error = errors.message.replace('GraphQL error:', ' ').trim();
        //if(silent) {
//          throw new Error(error);
        //} else {
          enqueueSnackbar( error, {variant:'error'});
        //}
      } else {
/*        if(silent) {
          throw new Error('An error has occurred');
        } else {*/
          enqueueSnackbar('An error has occurred', {variant:'error'});
        //}
      }
    }
  }, []);
  //[bookingCampaignId,bookingIsSlot,bookingNumWeeks,bookingType]);
  const changeWeek = useCallback((value) => {
    goToQueryString(query.array, format(value, 'yyyy-MM-dd'));
  }, [goToQueryString, query.array]);
  const inspectDate = useCallback((panelId, weekNum) => {
    setInspectedRecord((val)=>{
      if(val) { return {weekNum:weekNum,panelId:panelId,inspectorId:val.inspectorId+1}; }
      return {weekNum:weekNum,panelId:panelId,inspectorId:0};
    })
//    setInspectedRecord({ weekNum: weekNum, panelId: panelId, inspectorId: inspectorId + 1 });
    //setInspectorId(inspectorId + 1);
    //console.log('inspected', weekNum, panelId, inspectorId);
  }, []);
  
  useEffect(() => {
    if (panelResults.loading) {
      return;
    }
    const qResults: Panel[] = panelResults.data ? panelResults.data.panelSearch : null;
    setResults(qResults);
    const sortState = [{name: 'site.boroughOrRegion', asc: true}, {
      name: 'site.boroughOrRegion',
      asc: true
    }, {name: 'site.name', asc: true}, {name: 'panel', asc: true}];

    if (sortState.length && qResults && qResults.length) {
      const sortValues = qResults.map((e, i) => ({ind: i, val: e}));
      sortValues.sort(
        (x, y) => {
          let rv = 0;
          sortState.forEach((sorting) => {
            let ret;
            if (rv) return;
            const fieldA = get(x.val, sorting.name);
            const fieldB = get(y.val, sorting.name);
            if (sorting.asc) {
              ret = fieldA > fieldB ? 1 : (fieldA === fieldB ? 0 : -1);
            } else {
              ret = fieldA < fieldB ? 1 : (fieldA === fieldB ? 0 : -1);
            }
            if (ret) {
              rv = ret;
              return;
            }
          });
          return rv;
        }
      );
      setOrder(sortValues.map((e) => e.ind));

    } else {
      setOrder(qResults ? [qResults.keys()] : []);
    }
  }, [panelResults.data, panelResults.loading]);
  const toggleFrozen = (newVal) => {
    const seenKey = false;
    const newFrozenKey = newVal?{
      name:'frozen',
      type:'as',
      value:(+new Date).toString(36).slice(-5)
    }:null;
    const newFrozenVal = newVal?{
      name:'frozen',
      type:'date',
      value:format(query.week, 'yyyy-MM-dd')
    }:null;
    let newQuery = query.array.map(function(v) {
      if(v.name=='frozen') {
        return null;
      }
      return v;
    });
    if(!seenKey && newFrozenKey) {
      newQuery.push(newFrozenKey);
      newQuery.push(newFrozenVal);
    }
    newQuery = newQuery.filter(function(v) { return !!v; });
    goToQueryString(newQuery,format(query.week, 'yyyy-MM-dd'));
  };
//  const results: Panel[] = panelResults.data ? panelResults.data.panelSearch.data : null;
  return (
    <> {query.weekNum >0 
       &&<PanelSearch onSearch={doSearch} params={query.array} date={query.week} isOpen={isSearchOpen}
        onCancel={doCancelSearch} />
    }
    <ModalWindow isOpen={isOptionalModalShown} header="Are you sure?" onClose={()=>{setOptionModalShown(false)}}
    actions={<>
      <Button color="warning" onClick={()=>{setOptionModalShown(false)}}>Cancel</Button>
      <Button color="primary" onClick={()=>{doOptionAllPanelsAction(); setOptionModalShown(false)}}>Confirm</Button>
    </>}
    ><Typography variant="body1">Confirming will attempt to option every panel from the selected date for the specified number of weeks.
    </Typography>
    
    </ModalWindow>
        <div className="grid12">
          <div className="grid12-10 panel-booking__main">
            <PanelGrid
              bookDate={bookDate}
              inspectDate={inspectDate}
              changeWeek={changeWeek}
              loading={panelResults.loading} error={panelResults.error}
              order={resultsOrder}
              results={results}
              viewWeekNum={query.weekNum}
              viewWeek={query.week}
              toggleFrozen={toggleFrozen}
              isFrozen={query.params && !!query.params['frozen-as']}
            />
          </div>
          <div className="grid12-2 panel-booking__side">
            <div className="panel-booking__booking-widget">
              <Accordion defaultExpanded={true}>
                <AccordionSummary>Booking Options</AccordionSummary>
                <AccordionDetails>
                  <PanelBookingsSidebar changeOptions={setBookingOptions} optionAll={doOptionAllPanels} bookingType={bookingType} campaignId={bookingCampaignId} isSlot={!!bookingIsSlot} numWeeks={bookingNumWeeks} />
                </AccordionDetails>
              </Accordion>
              <div>
                {inspectedRecord &&
                  <PanelBookingsInspector weekNum={inspectedRecord.weekNum} panelId={inspectedRecord.panelId} inspectorId={inspectedRecord.inspectorId} />
                }
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

PanelBookings.defaultProps = {
  bookingType: 'Pencil',
  numWeeks:4,
  isSlot:false,
  campaignId:null
};


export default PanelBookings;